
<template>
  <!-- 应用授权-->
  <div class="application view-box">
    <navBan title="应用授权"></navBan>

    <ul class="cell-box">
      <li class="cell-item" v-for="(item, index) of productList.list" :key="index" @click="changeAuth(item)">
        <div class="cell-title">
          <img class="title-icon" :src="item.icon" alt="">
          <span class="title-text">{{item.label}}</span>
        </div>
        <div  class="cell-value">
          <span class="value-text">{{item.value}}</span>
          <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
        </div>
      </li>
    </ul>

    <!-- 解除授权的弹窗-->
    <div v-if="visible" class="modal-mask">
      <div class="modal-body">
        <p class="title">取消授权</p>
        <div class="icon-contai">
          <div class="icon-box">
            <img class="icon" :src="appItem.icon" alt="">
          </div>
        </div>
        <h3 class="app-name">{{appItem.label}}</h3>
        <ul class="tip">
          <li>
            <p>本应用拥有以下权限：</p>
            <p>访问您的公开信息（昵称、头像）</p>
            <p>访问您的实名信息</p>
          </li>
          <li style="margin-top: 24px">
            <p>取消授权后，再次使用此应用需要重新授权。</p>
          </li>
        </ul>
        <div class="btn-box">
          <button @click="cancelAuth" class="button button-plain button-danger">取消授权</button>
          <button @click="visible = false" class="button button-plain">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import navBan from '@/components/navBan';
import { onBeforeMount } from 'vue';
import { visible, appItem, productList, getAuthList, changeAuth, cancelAuth } from '@/utils/setup/appAuth';
import {useRouter} from 'vue-router';

onBeforeMount(() => {
  getAuthList();
});
const router = useRouter();
router.beforeEach((to, from, next) => {
  visible.value = false;
  next();
});

</script>

<style lang="scss" scoped>
.cell-box{
  padding:0 32px;
  box-sizing: border-box;
  background: white;
}
.application {
  padding: 16px 0 16px;
  .cell-item {
    margin-bottom: 16px;
  }
  .title {
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #00132E;
    line-height: 20px;
  }
  .icon-contai {
    margin-top: 32px;
    display: flex;
    justify-content: center;
    .icon-box {
      width: 72px;
      height: 72px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .tip {
    margin-top: 16px;
    font-size: 14px;
    line-height: 18px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #868F9C;
  }
}
</style>
